import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/plugins'
import 'lib-flexible/flexible'
import 'normalize.css/normalize.css'
import './common/font/font.css'
import './styles'
import Api from './utils/http.js'
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
]
Vue.prototype.$api = Api
Vue.use(require('vue-wechat-title'))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
